import { createApp } from 'vue';
import App from './App.vue';
import './assets/main.css';
import router from './router';
import { i18n, loadLocale } from './i18n/i18n';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
(function redirectSubdomainToHogar() {
    const host = window.location.hostname;
    if (host === 'aseguratuhogar.inbros.mx') {
        const hash = window.location.hash;
        if (!hash || hash === '#' || hash === '#/' || hash === '#/') {
            window.location.replace('/#/CotizadorHogar');
        }
    }
})();
async function bootstrap() {
    const app = createApp(App);
    app.use(router);
    app.use(i18n);
    app.use(Toast, {
        position: 'top-right',
        timeout: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    });
    const savedLocale = localStorage.getItem('locale') || 'es';
    await loadLocale(savedLocale);
    app.mount('#app');
}
bootstrap();
